import { render, staticRenderFns } from "./SaleSquareMeter.vue?vue&type=template&id=2215199a&scoped=true&"
import script from "./SaleSquareMeter.vue?vue&type=script&lang=js&"
export * from "./SaleSquareMeter.vue?vue&type=script&lang=js&"
import style0 from "./SaleSquareMeter.vue?vue&type=style&index=0&id=2215199a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2215199a",
  null
  
)

export default component.exports